import { render } from "./right-bar-fw.vue?vue&type=template&id=45cad6e5"
import script from "./right-bar-fw.vue?vue&type=script&lang=js"
export * from "./right-bar-fw.vue?vue&type=script&lang=js"

import "./right-bar-fw.vue?vue&type=style&index=0&id=45cad6e5&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__